import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 'mapset-s100m01',
    templateUrl: './mapset-s100m01.component.html'
})
export class MapsetS100m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    select: any = {'value': '_'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'select', 'msgln'];
    public LINES: number[] = [1, 2, 6, 22, 23, 8, 24, 10, 12, 14];

    ngAfterViewInit(): void {
    }

    selectChange() {
            if (this.msgln.value) {
                if (this.msgln.value.trim() == "INVALID SELECTION") {
                    const input = document.querySelector('#select');
                    (input as HTMLElement).style.color = '#db2d20';
                    (input as HTMLElement).style.borderBottomColor = 'white';
                } else {
                    const input = document.querySelector('#select');
                    (input as HTMLElement).style.color = '#32d13f';
                    (input as HTMLElement).style.borderBottomColor = '#32d13f';
                }
            }
        }
}
